import React from "react";
import Slider from "react-slick";

function SampleNextArrow(props) {
    const { className, onClick } = props;

    return (
        <div className={className} onClick={onClick}>
            <i className="fal fa-chevron-right" aria-hidden="true"/>
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;

    return (
        <div className={className} onClick={onClick}>
            <i className="fal fa-chevron-left" aria-hidden="true"/>
        </div>
    );
}

class TrendsNav extends React.Component {
    state = {
        isClient: false
    }

    componentDidMount() {
        this.setState({isClient: true});
    }

    render() {
      const { menuItems, title, sponsorLogo, cleanURL } = this.props;

      let slidesToShow = menuItems.length > 5 ? 5.25 : menuItems.length;
      let currentSlide = menuItems.findIndex((item) => item.isCurrent);
      let initialSlide = 0;

      if (this.state.isClient) {
        let smSlidesToShow = 1.25;
        let mdSlidesToShow = 3.25;
        let lgSlidesToShow = 3.25;

        if (window.innerWidth <= 568) {
          slidesToShow = menuItems.length - 1 > Math.floor(smSlidesToShow) ? smSlidesToShow : menuItems.length;
        } else if (window.innerWidth <= 800) {
          slidesToShow = menuItems.length - 1 > Math.floor(mdSlidesToShow) ? mdSlidesToShow : menuItems.length;
        } else if (window.innerWidth <= 1200) {
          slidesToShow = menuItems.length - 1 > Math.floor(lgSlidesToShow) ? lgSlidesToShow : menuItems.length;
        }
      }

      if (currentSlide >= Math.floor(slidesToShow)) {
        initialSlide = currentSlide - Math.floor(slidesToShow) + 1;
      }

      const sliderConfig = {
        dots: false,
        lazyLoad: true,
        infinite: false,
        centerMode: false,
        initialSlide: initialSlide,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        swipeToSlide: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />
      };
      return (
        <div className="NavBackground">
          <div className="TrendsNav">
            {sponsorLogo && (
              <div className="TrendsSponsor">
                <p>Series Sponsor</p>
                <picture>
                  {sponsorLogo.sourceTagData.map((data, index) => {
                    return <source key={index} media={data.media} srcSet={data.srcset} type={data.type} />;
                  })}
                  <img
                    className={sponsorLogo.imageTagData.class}
                    src={sponsorLogo.imageTagData.src}
                    alt={sponsorLogo.imageTagData.alt}
                    title={sponsorLogo.imageTagData.title}
                    loading="auto"
                  ></img>
                </picture>
              </div>
            )}
            <div className="seriesTitle">
              {menuItems.length}-part series
              <br />
              <span>
                <a href={`/series-entry/${cleanURL}`} dangerouslySetInnerHTML={{ __html: title }}></a>
              </span>
            </div>
            <nav className="menu-wrapper">
              <div className="menu">
                <Slider {...sliderConfig} ref={(slider) => (this.slider = slider && slider["innerSlider"])}>
                  {menuItems.map((item, index) => {
                    return (
                      <div key={index} className={`ideaNavItem item ${item.isCurrent ? "active" : ""} `}>
                        <a href={item.url}>
                          <p className="max-3-lines" dangerouslySetInnerHTML={{ __html: item.label }}></p>
                        </a>
                      </div>
                    );
                  })}
                </Slider>
              </div>
            </nav>
          </div>
        </div>
      );
    }
}

export default TrendsNav;
